import script from "./PaginationFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./PaginationFooter.vue?vue&type=script&setup=true&lang=js"

import "./PaginationFooter.vue?vue&type=style&index=0&id=29e88fc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29e88fc4"]])

export default __exports__